import { BATCH_STARTING_STATE_MESSAGE } from "@/services/batchIngestionSession";
import type { BatchExtractionStatus } from "@/services/api";

export interface ExtractionProgressModel {
  totalFiles: number;
  completedCount: number;
  percent: number;
  primaryLabel: string;
  detailLabel: string | null;
  isStarting: boolean;
}

function buildDetailLabel(batchStatus: BatchExtractionStatus): string | null {
  const parts: string[] = [];
  if (batchStatus.runningCount > 0) {
    parts.push(`${batchStatus.runningCount} processing`);
  }
  if (batchStatus.pendingCount > 0) {
    parts.push(`${batchStatus.pendingCount} queued`);
  }
  return parts.length > 0 ? parts.join(" · ") : null;
}

function fileWord(count: number): string {
  return count === 1 ? "file" : "files";
}

export function buildExtractionProgressModel(
  batchStatus: BatchExtractionStatus
): ExtractionProgressModel {
  const totalFiles = batchStatus.totalFiles;
  const completedCount =
    batchStatus.succeededCount +
    batchStatus.failedCount +
    batchStatus.skippedCount +
    batchStatus.cancelledCount;
  const percent =
    totalFiles > 0 ? Math.min(100, Math.round((completedCount / totalFiles) * 100)) : 0;
  const isStarting = batchStatus.items.some(
    (item) => item.stateMessage === BATCH_STARTING_STATE_MESSAGE
  );

  const primaryLabel = `Ingesting ${completedCount} of ${totalFiles} ${fileWord(totalFiles)}…`;

  return {
    totalFiles,
    completedCount,
    percent,
    primaryLabel,
    detailLabel: isStarting || completedCount >= totalFiles ? null : buildDetailLabel(batchStatus),
    isStarting,
  };
}
